var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52285_37349)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.671875 7.9974C0.671875 3.94731 3.95512 0.664062 8.00521 0.664062C12.0553 0.664062 15.3385 3.94731 15.3385 7.9974C15.3385 12.0475 12.0553 15.3307 8.00521 15.3307C3.95512 15.3307 0.671875 12.0475 0.671875 7.9974Z",
    fill: "#FAD271"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00547 3.43758C7.91462 3.4362 7.82441 3.45298 7.74012 3.48692C7.65584 3.52086 7.57918 3.57128 7.51464 3.63524C7.4501 3.69919 7.39898 3.77538 7.36427 3.85935C7.32956 3.94332 7.31197 4.03337 7.31251 4.12423L7.44065 9.70427C7.44593 9.84983 7.50801 9.98753 7.61358 10.0879C7.71916 10.1882 7.85983 10.2432 8.00547 10.2411C8.15108 10.2432 8.29172 10.1882 8.39727 10.0878C8.50281 9.98748 8.56487 9.8498 8.57016 9.70427L8.69842 4.12423C8.69897 4.03337 8.68137 3.94332 8.64666 3.85935C8.61195 3.77538 8.56083 3.69919 8.49629 3.63524C8.43175 3.57128 8.35509 3.52086 8.27081 3.48692C8.18652 3.45298 8.09631 3.4362 8.00547 3.43758Z",
    fill: "#423E4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00595 12.8244C8.42345 12.8244 8.7619 12.4859 8.7619 12.0684C8.7619 11.6509 8.42345 11.3125 8.00595 11.3125C7.58845 11.3125 7.25 11.6509 7.25 12.0684C7.25 12.4859 7.58845 12.8244 8.00595 12.8244Z",
    fill: "#423E4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52285_37349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircle);
export default __webpack_public_path__ + "static/media/warningCircle.50c0b98eccc620337c177772d9b146ab.svg";
export { ForwardRef as ReactComponent };